<template>
  <!-- FT-1487: THE TOWN-LAYOUT LAB (Tl) — the town's geometry, dialled per
       backdrop. The seat ring's radius and oval, and the central cross area's
       position, slot size and spread. Every dial is SAVED AGAINST THE LIVE
       BACKDROP (golem/townLayout): each backdrop's painting puts the panels in
       a different place, so each remembers its own ring and cross. Behind
       `devLabs` with the rest of the dev column, same shell so they read as
       one toolkit. -->
  <div id="town-layout-lab" :class="{ open: open }">
    <button
      type="button"
      class="fd-toggle"
      title="Town layout — the seat ring + central cross, per backdrop"
      @click="open = !open"
    >
      Town layout
    </button>
    <div class="fl-rows" v-if="open">
      <div class="fl-head">
        Geometry
        <span class="fl-phase">{{ bgLabel }}</span>
      </div>
      <div class="fl-row" v-for="d in dials" :key="d.key">
        <span class="fl-label" :title="d.label">{{ d.label }}</span>
        <input
          type="range"
          :min="d.min"
          :max="d.max"
          :step="d.step"
          :value="layout.dials[d.key]"
          @input="onDial(d.key, $event.target.value)"
        />
        <span class="fl-val">{{ fmt(layout.dials[d.key]) }}</span>
      </div>
      <label class="fl-check">
        <input
          type="checkbox"
          :checked="layout.outline"
          @change="onOutline($event.target.checked)"
        />
        <span>Show slots</span>
      </label>
      <button class="fl-reset" @click="reset">Reset</button>
    </div>
  </div>
</template>

<script>
import { TOWN_BGS } from "../golem/townBg";
import {
  DIALS,
  townLayoutState,
  setDial,
  setOutline,
  resetLayout,
} from "../golem/townLayout";

export default {
  data() {
    return { open: false, dials: DIALS, layout: townLayoutState };
  },
  computed: {
    bgLabel() {
      const b = TOWN_BGS.find((x) => x.id === this.layout.bg);
      return b ? b.label : this.layout.bg;
    },
  },
  methods: {
    onDial(key, value) {
      setDial(key, value);
    },
    onOutline(on) {
      setOutline(on);
    },
    reset() {
      resetLayout();
    },
    fmt(v) {
      return Number(v).toFixed(2).replace(/\.00$/, "");
    },
  },
};
</script>

<style scoped lang="scss">
// FT-1487 — the ladder's next rung below the reader lab (top: 402px).
#town-layout-lab {
  position: fixed;
  top: 426px;
  left: 0;
  z-index: 60;
  display: flex;
  align-items: flex-start;
  font-size: 13px;

  // NOT ON A PHONE — the dev column lands on top of real chrome there.
  @media (pointer: coarse) {
    display: none;
  }

  .fd-toggle {
    width: 132px;
    height: 22px;
    line-height: 20px;
    padding: 0 10px;
    box-sizing: border-box;
    text-align: left;
    white-space: nowrap;
    font-family: inherit;
    font-size: 12px;
    color: #d8cdb4;
    background: rgba(0, 0, 0, 0.6);
    border: 1px solid #3d3d3d;
    border-left: none;
    border-radius: 0 6px 6px 0;
    cursor: pointer;
    opacity: 0.45;
    &:hover,
    &:focus-visible {
      opacity: 1;
      border-color: rgba(var(--reader-rgb), 0.75);
      outline: none;
    }
  }
  &.open .fd-toggle {
    opacity: 1;
    border-color: rgba(var(--reader-rgb), 0.75);
  }

  .fl-rows {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 8px;
    background: rgba(8, 6, 10, 0.92);
    border: 1px solid rgba(var(--reader-rgb), 0.45);
    border-left: none;
    border-radius: 0 8px 8px 0;
    max-height: calc(100vh - 200px);
    overflow-y: auto;
  }
  .fl-head {
    display: flex;
    align-items: baseline;
    gap: 6px;
    font-size: 10px;
    letter-spacing: 0.09em;
    text-transform: uppercase;
    color: #b6a8c8;
    opacity: 0.85;
    padding-bottom: 3px;
    border-bottom: 1px solid rgba(var(--reader-rgb), 0.28);
  }
  .fl-phase {
    font-size: 9px;
    letter-spacing: 0.04em;
    text-transform: none;
    color: rgb(var(--reader-rgb));
  }
  .fl-row {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    color: #d8cdb4;
    input[type="range"] {
      width: 96px;
    }
  }
  .fl-label {
    width: 74px;
    white-space: nowrap;
    opacity: 0.7;
    cursor: help;
  }
  .fl-val {
    width: 34px;
    text-align: right;
    opacity: 0.85;
    font-variant-numeric: tabular-nums;
  }
  .fl-check {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: #d8cdb4;
    cursor: pointer;
    margin-top: 2px;
  }
  .fl-reset {
    margin-top: 4px;
    font-family: inherit;
    font-size: 11px;
    color: #cdc2e2;
    background: rgba(20, 16, 22, 0.9);
    border: 1px solid rgba(var(--reader-rgb), 0.4);
    border-radius: 5px;
    padding: 3px 6px;
    cursor: pointer;
    &:hover,
    &:focus-visible {
      border-color: rgba(var(--reader-rgb), 0.75);
      outline: none;
    }
  }
}
</style>
